interface EmptyChartMessageProps {
  containerWidth?: string;
}
const EmptyChartMessage = ({ containerWidth }: EmptyChartMessageProps) => {
  return (
    <div style={containerWidth ? { width: `${containerWidth}` } : undefined}>
      There is no data available to display in a chart. Would you like to modify
      your criteria and try again?
    </div>
  );
};

export default EmptyChartMessage;
